document.addEventListener("DOMContentLoaded", () => {
  const faqLists = document.querySelectorAll("[data-as-faq-list]");

  faqLists.forEach((list) => {
    const mode = list.dataset.mode || "accordion";
    const items = Array.from(list.querySelectorAll("[data-as-faq-item]"));
    const loadMoreButton = list.parentElement.querySelector(
      "[data-as-faq-load-more]",
    );

    const initialCount = Number(list.dataset.initialCount || items.length);
    const loadCount = Number(list.dataset.loadCount || items.length);

    let visibleCount = initialCount;

    const closeItem = (item) => {
      const answer = item.querySelector("[data-as-faq-answer]");
      if (!answer) return;

      const currentHeight = answer.scrollHeight;

      answer.style.height = `${currentHeight}px`;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          item.classList.remove("is-active");
          answer.style.height = "0px";
        });
      });
    };

    const openItem = (item) => {
      const answer = item.querySelector("[data-as-faq-answer]");
      if (!answer) return;

      item.classList.add("is-active");
      answer.style.height = "0px";

      requestAnimationFrame(() => {
        answer.style.height = `${answer.scrollHeight}px`;
      });

      answer.addEventListener(
        "transitionend",
        () => {
          if (item.classList.contains("is-active")) {
            answer.style.height = "auto";
          }
        },
        { once: true },
      );
    };

    const updateVisibleItems = (animate = false, previousCount = 0) => {
      items.forEach((item, index) => {
        const shouldHide = index >= visibleCount;

        if (!shouldHide && animate && index >= previousCount) {
          item.classList.remove("is-hidden");
          item.classList.add("is-revealing");

          requestAnimationFrame(() => {
            item.classList.add("is-visible");
          });

          setTimeout(() => {
            item.classList.remove("is-revealing", "is-visible");
          }, 450);

          return;
        }

        item.classList.toggle("is-hidden", shouldHide);
      });

      if (loadMoreButton) {
        loadMoreButton.classList.toggle(
          "is-hidden",
          visibleCount >= items.length,
        );
      }
    };

    updateVisibleItems();

    if (mode === "expanded") {
      items.forEach((item) => {
        const answer = item.querySelector("[data-as-faq-answer]");
        item.classList.add("is-active");
        if (answer) answer.style.height = "auto";
      });
    }

    if (mode === "accordion") {
      const openedItems = items.filter((item) =>
        item.classList.contains("is-active"),
      );

      openedItems.forEach((item, index) => {
        const answer = item.querySelector("[data-as-faq-answer]");

        if (index === 0) {
          item.classList.add("is-active");
          if (answer) answer.style.height = "auto";
        } else {
          item.classList.remove("is-active");
          if (answer) answer.style.height = "0px";
        }
      });
    }
    items.forEach((item) => {
      item.addEventListener("click", (event) => {
        if (mode === "expanded") return;

        const isActive = item.classList.contains("is-active");

        if (isActive) {
          closeItem(item);
          return;
        }

        items.forEach((currentItem) => {
          if (
            currentItem !== item &&
            currentItem.classList.contains("is-active")
          ) {
            closeItem(currentItem);
          }
        });

        openItem(item);
      });
    });
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", () => {
        const previousCount = visibleCount;

        visibleCount = Math.min(visibleCount + loadCount, items.length);

        updateVisibleItems(true, previousCount);
      });
    }
  });
});
